import React, { Component } from "react";
import SaltComply from "../images/SaltStack_Comply_black.png";
import SaltProtect from "../images/SaltStack_Protect_black.png";

export default class TwoColumnsCards extends Component {
  render() {
    return (
      <div className="bg-gray-900">
        <div className="pt-12 sm:pt-16 lg:pt-24">
          <div className="max-w-screen-xl mx-auto text-center px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto lg:max-w-none">
              <p className="mt-2 text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none">
                Powerful products to secure IT
              </p>
            </div>
          </div>
        </div>
        <div className="mt-8 pb-12 bg-gray-900 sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
          <div className="relative">
            <div className="absolute inset-0 h-3/4 bg-gray-900"></div>
            <div className="relative z-10 max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-md mx-auto lg:max-w-5xl lg:grid lg:grid-cols-2 lg:gap-5 items-start">
                <div className="rounded-lg shadow-lg overflow-hidden">
                  <div className="bg-white sm:p-10 p-8">
                    <img className="w-1/2 my-6" src={SaltComply} />
                    <div className="my-4 flex items-baseline leading-none font-extrabold">
                      <span className="text-2xl font-medium text-gray-900">
                        Active vulnerability remediation
                      </span>
                    </div>
                    <div>
                      <span className="mt-5 text-gray-600 ">
                        SaltStack Protect actively ingests vendor CVE
                        advisories, builds scans and remediation workflows to
                        address them, and delivers this security content to
                        customers as a service. Security and operations teams
                        can then use SaltStack configuration automation to check
                        installed package versions on all systems, identify
                        vulnerabilities, and install patches to remediate them.
                      </span>
                    </div>
                  </div>

                  <div className="px-6 pt-6 pb-8 bg-gray-200 sm:p-10 sm:pt-6"></div>
                </div>
                <div className="mt-4 rounded-lg shadow-lg overflow-hidden lg:mt-0 self-stretch">
                  <div className="bg-white sm:p-10 p-8">
                    <img className="w-1/2 my-6" src={SaltProtect} />
                    <div className="my-4 flex items-baseline leading-none font-extrabold">
                      <span className="text-2xl font-medium text-gray-900">
                        Continuous compliance
                      </span>
                    </div>
                    <div>
                      <span className="mt-5 text-gray-600 ">
                        SaltStack Comply includes access to a live and growing
                        repository of industry-standard compliance profiles.
                        Each profile includes hundreds of up-to-date issue
                        scans, descriptions, and automated remediation actions.
                        Users can also create jobs for review and approval
                        before changes are executed. SaltStack integrates with
                        third-party systems like ServiceNow for change tracking
                        and reporting.
                      </span>
                    </div>
                  </div>
                  <div className="px-6 pt-6 pb-8 bg-gray-200 sm:p-10 sm:pt-6"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
